import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { finishGoogle } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    finishGoogle(match[1])
      .then((u) => {
        toast.success(`Signed in as ${u.email}`);
        navigate(u.active_role === "investor" ? "/investor" : "/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      });
  }, [finishGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fdfcf8]">
      <div className="font-serif text-2xl text-[#0b192c]">Finishing sign-in…</div>
    </div>
  );
}
